/**
 * Shared constants for UserManagement components
 * Centralizes dropdown values and provides helpers to build options with i18n labels
 */

import { ROLE_VALUES } from '../../constants';

/** User status tabs configuration (base structure) */
export const STATUS_TABS_BASE = [
  { key: 'verified', labelKey: 'verified' },
  { key: 'closed', labelKey: 'closed' },
  { key: 'unverified', labelKey: 'unverified' },
] as const;

/**
 * Build role options array from translations
 * @param translations - i18n translations object with roles
 * @returns Array of {value, label} options for role dropdown
 */
export function buildRoleOptions(translations?: Record<string, string>) {
  return ROLE_VALUES.map(value => ({
    value,
    label: translations?.[value] || value
  }));
}

/**
 * Build status tabs array from translations
 * @param translations - i18n translations object with tabs
 * @returns Array of {key, label} options for status tabs
 */
export function buildStatusTabs(translations?: Record<string, string>) {
  return STATUS_TABS_BASE.map(tab => ({
    key: tab.key,
    label: translations?.[tab.labelKey] || tab.labelKey,
  }));
}
